export default {
  // 顶部菜单布局演示
  StoreOperations: 'Store Operations',
  CommonCenter: 'Cashier POS',
  ProductManage: 'Products',
  OrderManage: 'Orders',
  Membership: 'Member CRM',
  SmartStore: 'Smart Store',
  AllPhenomena: 'Business Growth',
  DataAnalysis: 'Data Analytics',
  DemoMiniOrder: 'Mini Program Orders',
  DemoMore: 'More ›',
  DemoPlatformBusiness: 'Platform Business',
  DemoDeliveryCenter: 'Delivery Center',
  DemoGroupBuying: 'Group Buying',
  DemoRetailMall: 'Retail Mall',
  DemoQueue: 'Order Pickup',
  DemoDelivery: 'Delivery Services',
  DemoReservation: 'Reservations',
  DemoMealScreen: 'Order Display',
  DemoMarketingAutomation: 'Marketing Automation MA',
  DemoSocialCRM: 'Social CRM',
  DemoMarketing: 'Marketing',
  DemoCardManagement: 'Cards and Coupons',
  DemoMemberData: 'Member Data',
  DemoSupplyChain: 'Supply Chain',
  DemoSmartWarning: 'Smart Alerts',
  DemoBrandControl: 'Brand Cost Control',
  DemoFinanceManagement: 'Finance',
  DemoFinanceAccounting: 'Accounting',
  DemoInvoice: 'Invoice Management 1.0',
  DemoFinanceVoucher: 'Financial Vouchers',
  BizManag: 'Business Management',
  Set: 'Brand-level Business Settings',
  OperateSettlement: 'Business Settlement',
  DailyBoard: 'Daily Settlement Dashboard',
  OperateReport: 'Business Reports',
  AccountCenterHome: 'Account Center',
  AccountCenterPassword: 'Change Password',
  OnlineOperation: 'Online Operations',
  PlatformBusiness: 'Platform Business',
  GroupBuying: 'Group Buying',
  Advert: 'Advertisement Management',
  AdvertEdit: 'Advertisement Settings',
  Decorate: 'Decoration Management',
  DecorateAdd: 'Decoration Template Settings',
  MiniProgramManage: 'Mini Program Management',
  Template: 'Template Library',
  ChannelManage: 'Channel Management',
  ProjectDeduction: 'Device Operations',
  Project: 'Charge Rules',
  Deduction: 'Charge Management',
  Record: 'Project Charge Records',
  DeviceManage: 'Device Management',
  DeviceAuthorization: 'Device Authorization',
  // Operation tools (backend menus: device operations/operation tools/device activation)
  OperationTools: 'Operation Tools',
  DeviceActivation: 'Device Activation',
  ChargeScene: 'Charge Scene',
  // Cashier device (backend menu: device operations/device management/cashier device)
  CashierDevice: 'Cashier Device',
  // Fee center (backend menus: feeCenter/service, feeCenter/order; dynamic route name = capitalized path)
  FeeCenter: 'Fee Center',
  FeeCenterService: 'Value-added Services',
  FeeCenterOrder: 'Order Management',
  Service: 'Value-added Services',
  Order: 'Order Management',
  FeeCenterOrderConfirm: 'Confirm Order',
  FeeCenterPayment: 'Order Payment',
  AssetScope: 'Asset Usage Rules',
};
